'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @primitive Popover
 * ROLE: dialog (implicit via Radix) | ARIA: aria-haspopup, aria-expanded on trigger
 * KEYBOARD: ESC closes and restores focus to trigger; Tab moves through content
 * FOCUS: enters first focusable element in content on open; restores to trigger on close
 * LIVE-REGION: none
 * PRM: animation disabled; opacity instant
 * FORCED-COLORS: content border = ButtonText
 * RTL: side/align flips via Radix align logic; direction-agnostic
 * RSC: CLIENT
 * WAI-APG: https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/
 * SUBSTRATE: @radix-ui/react-popover
 */
import * as RadixPopover from '@radix-ui/react-popover';
import styles from './Popover.module.css';
export function Popover({ open, onOpenChange, trigger, virtualAnchor, children, side = 'bottom', align = 'start', sideOffset = 8, collisionPadding = 12, allowOverflow = false, matchAnchorWidth = false, onOpenAutoFocus, onCloseAutoFocus, onEscapeKeyDown, onPointerDownOutside, }) {
    // Radix expects a `RefObject`-shaped `virtualRef`. Construct one inline so
    // the caller can pass any object with `getBoundingClientRect`.
    const virtualRef = virtualAnchor !== undefined && virtualAnchor !== null
        ? { current: virtualAnchor }
        : undefined;
    return (_jsxs(RadixPopover.Root, { open: open, onOpenChange: onOpenChange, children: [trigger !== undefined ? (_jsx(RadixPopover.Trigger, { asChild: true, children: trigger })) : null, virtualRef !== undefined ? (_jsx(RadixPopover.Anchor, { virtualRef: virtualRef })) : null, _jsx(RadixPopover.Portal, { children: _jsx(RadixPopover.Content, { className: matchAnchorWidth ? `${styles.content} ${styles.matchAnchor}` : styles.content, side: side, align: align, sideOffset: sideOffset, collisionPadding: collisionPadding, style: allowOverflow ? { overflow: 'visible' } : undefined, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, children: children }) })] }));
}
//# sourceMappingURL=Popover.js.map